import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap';

const ProjectErrors = (props) => {
  const [show, setShow] = useState(false)

  useEffect(() => setShow(props.projectErrors != null && props.projectErrors.length > 0))
  if (!props.projectErrors) return null

  return (
    <Modal show={show} onHide={props.onCloseErrors}>
      <Modal.Header closeButton>
        Project Errors
      </Modal.Header>
      <Modal.Body>
        <ul className="list-unstyled">
          {props.projectErrors.map((err, idx) => (
            <li key={idx}>{err}</li>
          ))}
        </ul>
      </Modal.Body>
    </Modal>
  )
}

export default ProjectErrors
